/**
 * Pre-defined Questions for AURA Robot
 * 
 * This file contains a comprehensive list of suggested questions that users
 * can ask AURA. Questions are organized by category for better UX.
 */

export const PREDEFINED_QUESTIONS = {
  // Market Status & Overview
  marketStatus: [
    "What's the market doing?",
    "What's the current NIFTY50 price?",
    "How is NIFTY50 performing today?",
    "What's the market status?",
    "Is the market bullish or bearish?",
    "What's the market trend?"
  ],

  // Pivot Points & Key Levels
  pivotLevels: [
    "What are the pivot points?",
    "What's the pivot point for today?",
    "Show me support and resistance levels",
    "What are the key support levels?",
    "What are the key resistance levels?",
    "Where is the pivot point?"
  ],

  // Trading Signals
  tradingSignals: [
    "Should I buy now?",
    "Should I sell now?",
    "Is there a buy signal?",
    "Is there a sell signal?",
    "What's the current trading signal?",
    "Should I go long or short?",
    "What's your trading recommendation?"
  ],

  // Entry, Target & Stop Loss
  entryTargets: [
    "What's the entry price?",
    "What's the target price?",
    "What's the stop loss?",
    "Where should I enter?",
    "Where should I take profit?",
    "What's the risk-reward ratio?"
  ],

  // Strategy & Analysis
  strategy: [
    "What strategy is active?",
    "Which strategy should I use?",
    "What's the current setup?",
    "What pattern do you see?",
    "What's the market analysis?",
    "Explain the current strategy"
  ],

  // Market Prediction
  prediction: [
    "What's your prediction for NIFTY50?",
    "Where will NIFTY50 go next?",
    "What's the next move?",
    "What's the market outlook?",
    "What's your forecast?"
  ],

  // Support & Resistance
  supportResistance: [
    "What's the support?",
    "What's the resistance?",
    "Where is support?",
    "Where is resistance?",
    "What are the support levels?",
    "What are the resistance levels?"
  ],

  // Post-Market & Pre-Market
  postMarket: [
    "What was the closing price?",
    "What are tomorrow's pivot points?",
    "What happened in the market today?",
    "What's the market summary?",
    "What are the key levels for tomorrow?"
  ],

  // General Help
  help: [
    "What can you do?",
    "How can you help me?",
    "What questions can I ask?",
    "What features do you have?",
    "Help me understand the market"
  ]
};

/**
 * Get all questions as a flat array
 */
export const getAllQuestions = () => {
  return Object.values(PREDEFINED_QUESTIONS).flat();
};

/**
 * Get questions by category
 */
export const getQuestionsByCategory = (category) => {
  return PREDEFINED_QUESTIONS[category] || [];
};

/**
 * Get random questions (useful for suggestions)
 */
export const getRandomQuestions = (count = 3) => {
  const allQuestions = getAllQuestions();
  const shuffled = [...allQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

/**
 * Get featured questions (most commonly asked)
 */
export const getFeaturedQuestions = () => {
  return [
    "What's the market doing?",
    "What are the pivot points?",
    "Should I buy now?",
    "What's the support?",
    "What's your prediction for NIFTY50?",
    "What's the current trading signal?"
  ];
};

/**
 * Search questions by keyword
 */
export const searchQuestions = (keyword) => {
  const allQuestions = getAllQuestions();
  const keywordLower = keyword.toLowerCase();
  return allQuestions.filter(question => 
    question.toLowerCase().includes(keywordLower)
  );
};

export default PREDEFINED_QUESTIONS;

